// Consultation/ConsultationLanguagesPicker.tsx
import React, {useEffect} from 'react';
import {Box, Checkbox, FormControlLabel, FormGroup, Typography} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {Controller} from 'react-hook-form';
import {AppDispatch, RootState} from "Redux/store";
import {fetchPsychologyParams} from "Redux/psychologyParamsSlice";

interface ConsultationLanguagesPickerProps {
    control: any;
}

const ConsultationLanguagesPicker: React.FC<ConsultationLanguagesPickerProps> = ({control}) => {
    const dispatch = useDispatch<AppDispatch>();
    const {languages, status} = useSelector((state: RootState) => state.psychologyParams);

    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchPsychologyParams());
        }
    }, [status, dispatch]);

    if (status === 'loading') {
        return <Typography>Загрузка языков...</Typography>;
    }

    if (status === 'failed') {
        return <Typography color="error">Ошибка загрузки языков</Typography>;
    }

    return (
        <Box>
            {languages && languages.length > 0 ? (
                <FormGroup row>
                    <Controller
                        name="consultation_languages"
                        control={control}
                        render={({field}) => (
                            <>
                                {languages.map((language) => (
                                    <FormControlLabel
                                        key={language.id}
                                        control={
                                            <Checkbox
                                                checked={field.value.includes(language.id)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        field.onChange([...field.value, language.id]);
                                                    } else {
                                                        field.onChange(field.value.filter((id: number) => id !== language.id));
                                                    }
                                                }}
                                            />
                                        }
                                        label={language.value}
                                    />
                                ))}
                            </>
                        )}
                    />
                </FormGroup>
            ) : (
                <Typography>Нет доступных языков.</Typography>
            )}
        </Box>
    );
};

export default ConsultationLanguagesPicker;
